import React, { lazy } from 'react'
import { Redirect } from '@reach/router'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import { BuildDelayedComponent } from 'common-tools/index'

// const App = lazy(() => import('./Views/App/App'))
const App = BuildDelayedComponent('App', () => import('./Views/App/App'))

class AppRoutePlain extends React.Component {
  render () {
    const { SessionToken, location } = this.props

    if (!SessionToken) {
      const target = location ? `${location.pathname}${location.search || ''}` : ''
      return <Redirect to={`/Login?returnURL=${encodeURIComponent(target)}`} />
      // return <Redirect to={`/Login`} />
    }

    return React.createElement(App, this.props)
  }
}

export const AppRoute = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.SessionAccount
  ])
)(AppRoutePlain)
